let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3M88q")).then(() => parcelRequire('3Htay'));